import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonIcon, fontColors } from '@sphereon/ui-components.core';
import SSIAddIcon from '../components/assets/icons/SSIAddIcon';
import SSIArrowDownIcon from '../components/assets/icons/SSIArrowDownIcon';
import MeatBallsIcon from '../components/assets/icons/MeatBallsIcon';
import CopyIcon from '../components/assets/icons/CopyIcon';
import DeleteIcon from '../components/assets/icons/DeleteIcon';
import SSIFilterIcon from '../components/assets/icons/SSIFilterIcon';
import PencilIcon from '../components/assets/icons/PencilIcon';
import ViewIcon from '../components/assets/icons/ViewIcon';
export const getIcon = (icon, color = fontColors.dark) => {
    switch (icon) {
        case ButtonIcon.ADD:
            return _jsx(SSIAddIcon, { color: color });
        case ButtonIcon.ARROW_DOWN:
            return _jsx(SSIArrowDownIcon, { color: color });
        case ButtonIcon.MEATBALLS:
            return _jsx(MeatBallsIcon, { color: color });
        case ButtonIcon.EDIT:
            return _jsx(PencilIcon, { color: color });
        case ButtonIcon.COPY:
            return _jsx(CopyIcon, { color: color });
        case ButtonIcon.DELETE:
            return _jsx(DeleteIcon, { color: color });
        case ButtonIcon.FILTER:
            return _jsx(SSIFilterIcon, { color: color });
        case ButtonIcon.VIEW:
            return _jsx(ViewIcon, { color: color });
        default:
            return _jsx("div", {});
    }
};
